import React from 'react';
import { motion } from 'framer-motion';
import { JaliDivider } from './JaliDivider';
import { useLanguage } from '../lib/LanguageContext';
export function WeddingEcosystem() {
  const {
    t
  } = useLanguage();
  return <section className="py-24 md:py-32 bg-sandstone relative" id="partner" data-id="element-195">
      <JaliDivider className="absolute top-0 left-0" data-id="element-196" />

      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center" data-id="element-197">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-198">
          <span className="text-saffron tracking-widest uppercase text-sm font-medium mb-4 block" data-id="element-199">
            {t('weddingEcosystem.eyebrow')}
          </span>
          <h2 className="text-3xl md:text-5xl font-heading text-navy mb-8" data-id="element-200">
            {t('weddingEcosystem.title')}
          </h2>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="mb-10" data-id="element-201">
            <div className="rounded-sm overflow-hidden shadow-xl border border-gold/20 mb-6" data-id="element-202">
              <img src="https://cdn.magicpatterns.com/uploads/6ajCEhJ7gMrag7RfAVytuR/Gemini_Generated_Image_q0e33oq0e33oq0e3.png" alt="Interior of the Darbar Sahib" className="w-full h-auto max-h-[500px] object-cover" data-id="element-203" />
            </div>
            <div className="bg-marble p-6 rounded-sm border border-gold/10 text-center shadow-sm" data-id="element-204">
              <p className="text-navy/80 text-base md:text-lg leading-relaxed italic" data-id="element-205">
                {t('weddingEcosystem.imageCaption')}
              </p>
            </div>
          </motion.div>

          <div className="bg-marble p-8 md:p-12 rounded-sm border border-gold/20 shadow-sm mb-10" data-id="element-206">
            <p className="text-navy/80 text-lg leading-relaxed mb-8" data-id="element-207">
              {t('weddingEcosystem.description')}
            </p>
            <p className="text-navy/60 italic mb-8" data-id="element-208">
              {t('weddingEcosystem.plannerNote')}
            </p>

            <a href="https://wa.me/6596670750" target="_blank" rel="noopener noreferrer" className="inline-block px-8 py-4 bg-saffron text-navy rounded-sm text-sm tracking-widest uppercase font-medium hover:bg-navy hover:text-ivory transition-colors duration-300" data-id="element-209">
              {t('weddingEcosystem.cta')}
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}